export const ROUTE_PATHS = {
  HOME: "/",
  ESPACIOS: "/espacios",
  MENU: "/menu",
  CONTACTO: "/contacto",
} as const;

export type RoutePath = (typeof ROUTE_PATHS)[keyof typeof ROUTE_PATHS];

export interface Espacio {
  id: string;
  nombre: string;
  slug: string;
  tagline: string;
  descripcion: string;
  descripcionLarga: string;
  imagenPrincipal: string;
  galeria: string[];
  amenidades: string[];
  horario?: string;
  rangoPrecio?: string;
}

export interface MenuItem {
  id: string;
  nombre: string;
  precio: number;
  descripcion: string;
  categoria: "entradas" | "especialidades" | "mariscos" | "bebidas" | "postres";
  imagen: string;
  esPopular?: boolean;
  origen: "Gaviotas" | "Medusas";
}

export interface Testimonio {
  id: string;
  nombre: string;
  comentario: string;
  calificacion: number;
  avatar?: string;
  fecha: string;
  servicioVisitado: "Restaurante Las Gaviotas" | "Cabañas Las Gaviotas" | "Restaurante Medusas";
}

/**
 * Formatea un precio numérico a moneda mexicana (MXN)
 */
export const formatPrice = (amount: number): string => {
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
  }).format(amount);
};

/**
 * Desplazamiento suave al inicio de la página
 */
export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};